module.exports = __webpack_public_path__ + "static/img/icon-order-dropdown.6da4c4ef.png";